import { useEffect, useState } from "react";

interface Activity {
  id: string;
  timestamp: string;
  username: string | null;
  device_label: string | null;
  event_type: string;
  stock_number: string | null;
  result: string;
}

export function ActivityPage() {
  const [rows, setRows] = useState<Activity[]>([]);
  useEffect(() => {
    fetch("/api/activity", { credentials: "same-origin" })
      .then((response) => response.json())
      .then(setRows);
  }, []);
  return (
    <div className="page">
      <div className="page-heading">
        <div>
          <h1>Immutable activity log</h1>
          <p>Every scan, edit, upload, location change, export, backup, and sign-in event.</p>
        </div>
      </div>
      <div className="table-wrap">
        <table className="inventory-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Event</th>
              <th>Stock number</th>
              <th>User</th>
              <th>Device</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td>{new Date(row.timestamp).toLocaleString()}</td>
                <td>{row.event_type.replaceAll("_", " ")}</td>
                <td>{row.stock_number || "—"}</td>
                <td>{row.username || "Anonymous"}</td>
                <td>{row.device_label || "—"}</td>
                <td>{row.result}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

